if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails || !this.elements.viewer) return;

      // Create pagination dots using non-variant slides only
      this.elements.pagination = this.createPaginationDots();

      // Listen for slideChanged event
      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      // Thumbnails click => setActiveMedia
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener(
          'click',
          this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true)
        );
      });

      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) {
        this.removeListSemantic();
      }
    }

   
    getMediaSlides() {
      return Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
    }

 
getNonVariantSlides() {
   let variantFound = false;
   return this.getMediaSlides().filter((slide) => {
     if (slide.hasAttribute('data-variant-image')) {
       console.log('Filtered out by data attribute:', slide);
       return false;
     }
     if (slide.classList.contains('product__media-item--variant')) {
       if (variantFound) {
       
         return false;
       }
       variantFound = true; 
     }
   
     return true;
   });
 }

  

refreshPaginationDots() {
  if (this.elements.pagination) {
    this.elements.pagination.remove(); // Remove existing dots
  }
  this.elements.pagination = this.createPaginationDots(); // Recreate dots
}

    // Create pagination dots for non-variant slides
 // Create pagination dots for non-variant slides only
createPaginationDots() {
  const dotsContainer = document.createElement('div');
  dotsContainer.classList.add('media-pagination-dots');

  // Filter non-variant slides
  const slides = this.getNonVariantSlides();

  slides.forEach((_, index) => {
    const dot = document.createElement('button');
    dot.classList.add('pagination-dot');
    if (index === 0) dot.classList.add('active'); // Set the first dot active by default
    dot.addEventListener('click', () => this.goToMedia(index));
    dotsContainer.appendChild(dot);
  });

  this.appendChild(dotsContainer);
  return dotsContainer;
}


    // Jump to a specific non-variant slide
    goToMedia(index) {
      const slides = this.getNonVariantSlides();
      const mediaElement = slides[index];
      if (!mediaElement) return;

      const mediaId = mediaElement.dataset.mediaId;
      if (mediaId) {
        this.setActiveMedia(mediaId, false, true);
      }
    }

    // Called when slideChanged event fires
    onSlideChanged(event) {
      if (event.detail.currentElement === undefined) return;

      const currentMediaId = event.detail.currentElement.dataset.mediaId;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${currentMediaId}"]`);
      this.setActiveThumbnail(thumbnail);
      this.setActiveDot(event.detail.currentElement);
    }

    /**
     * Sets the active media by mediaId.
     * If the media is variant media, we prepend it so it becomes the first thumbnail.
     */
    setActiveMedia(mediaId, prepend = false, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`li[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;
    
      const isVariant = activeMedia.hasAttribute('data-variant-image');
      if (isVariant) {
        prepend = true;
      }
    
      this.getMediaSlides().forEach(element => element.classList.remove('is-active'));
      activeMedia.classList.add('is-active');
    
      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
    
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          if (activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }
    
        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages();
        }
      }
    
      this.refreshPaginationDots(); // 🔥 Refresh the pagination dots here 🔥
    
      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });
    
      this.playActiveMedia(activeMedia);
    
      if (!this.elements.thumbnails) return;
    
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.setActiveDot(activeMedia);
    
      if (activeThumbnail && activeThumbnail.dataset.mediaPosition) {
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }
    

    
    setActiveDot(activeMedia) {
      if (!this.elements.pagination) return;
    
      const dots = this.elements.pagination.querySelectorAll('.pagination-dot');
      const slides = this.getNonVariantSlides();
      const index = slides.indexOf(activeMedia);
    
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }
    


    // Update the active thumbnail
    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach(element => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      // Scroll the thumbnail slider if needed
      if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = theme.accessibilityStrings.imageAvailable.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
    
  });
}
